export default __webpack_public_path__ + "static/media/THERMAL_FORMAT_1.8250f555.png";